export default {
      id: "check-usage",
      viewBox: "0 96 960 960",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#check-usage",
      toString: function () {
        return this.url;
      }
    }